import { useMutation } from 'react-query';
import {
  updateBettieSatisfaction,
  type UpdateBettieSatisfactionBody,
  type UpdateBettieSatisfactionResponse
} from '../../services/chatService';

export function useUpdateSatisfaction() {
  return useMutation<
    UpdateBettieSatisfactionResponse,
    Error,
    { body: UpdateBettieSatisfactionBody; chatRoomId: string }
  >(({ body, chatRoomId }) => updateBettieSatisfaction({ body, chatRoomId }));
}
